import { gql, useQuery } from '@apollo/client';
import React from 'react';
import Modal, { ModalTitle } from '../../components/Modal';
import UserProfileSettings from '../../graphql/fragments/UserProfileSettings';
import type {
  SettingsModalUserQuery,
  SettingsModalUserQueryVariables,
} from '../../graphql/generated/graphqlTypes';
import UserProfileSettingsForm from './UserProfileSettingsForm';

const USER_QUERY = gql`
  query settingsModalUser($id: ID!) {
    user(id: $id) {
      ...UserProfileSettings
    }
  }
  ${UserProfileSettings}
`;

interface UserProfileSettingsModalProps {
  close: () => void;
  id: string;
}

const UserProfileSettingsModal = ({
  close,
  id,
}: UserProfileSettingsModalProps) => {
  // Load user through apollo to ensure avatar gets reloaded when user is updated
  const { data: { user } = {} } = useQuery<
    SettingsModalUserQuery,
    SettingsModalUserQueryVariables
  >(USER_QUERY, {
    fetchPolicy: 'network-only',
    variables: { id },
  });

  return user ? (
    <Modal>
      <ModalTitle close={close}>Edit user profile</ModalTitle>
      <UserProfileSettingsForm user={user} onComplete={() => close()} />
    </Modal>
  ) : null;
};

export default UserProfileSettingsModal;
